<script lang="ts">
	import {Utils} from "./util";
	import {translations} from "./config";

	export let imgGradient = false;
	export let imagesLoaded = true;

	$: if (imgGradient) unsetLoaded();

	function unsetLoaded() {
		imagesLoaded = false;
	}
</script>

<div class="legend">
    <div class="legend-item">
        <span class="legend-circle mark-orange"></span>
        <span class="my-auto">{Utils.chooseTranslation(translations.legend.results)}</span>
    </div>
    <div class="legend-item">
        {#if imgGradient}
	        <img class="legend-circle" alt="" src="./map/img/striped.png" on:load={() => imagesLoaded = true}>
        {:else}
	         <span class="legend-circle mark-striped"></span>
        {/if}
        <span class="my-auto">{Utils.chooseTranslation(translations.legend.relative)}</span>
    </div>
    <div class="legend-item">
        <span class="legend-circle mark-dotted"></span>
        <span class="my-auto">{Utils.chooseTranslation(translations.legend.proportional)}</span>
    </div>
</div>

<style>

	img {

	}
    .legend {
        min-width: max-content;
    }

    .legend-item {
        display: flex;
        margin-top: 5px;
    }

    .legend-circle {
        display: block;
        border-radius: 50%;
        width: 2.5rem;
        height: 2.5rem;
        margin: 0 1rem 0 0;

        /* Keep background color when printing */
        color-adjust: exact;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .mark-orange {
        background: #FE6D50;
    }

    .mark-striped {
        background: repeating-linear-gradient(-45deg, #AEEAEC, #AEEAEC 2px, transparent 2px, transparent 7px);
    }

    .mark-dotted {
        background-image: radial-gradient(#AEEAEC 40%, transparent 40%);
        background-position: 0 0;
        background-size: 5px 5px;
    }
</style>
